export interface IScreenshotProps {
  isFrozen?: boolean;
  onChange: (screenshot: HTMLCanvasElement) => void;
  onDrawing: () => void;
  onPreview: () => void;
  onRevert: () => void;
  screenshot?: HTMLCanvasElement;
}

export interface IScreenshotState {
  hasScreenshotBeenChanged: boolean;
  mode: Mode;
}

export enum Mode {
  Drawing = 'drawing',
  Preview = 'preview',
}
